import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/Spectrum UXP Widgets/Using with React";
import * as React from 'react';
export default {
  Content,
  React
};